define('models/shared/lookups/route',["backbone"
], function (Backbone) {
    var Route = Backbone.Model.extend({
        url: function () {
            var url = pf.lookupsURL + "/Route";
            return url;
        },
        initialize: function (attributes, options) {
            options || (options = {});
        }
    });
    return Route;
});

